// frontend/src/utils/productApi.js
import { apiFetch } from './api';

const PRODUCT_ENDPOINT = '/products';

/**
 * 🌟 既存の関数：商品（親）と複数のSKU（子）を一括でマトリクス登録する
 * @param {Object} productData - 登録する商品・SKUデータ
 * @param {string} supplierCode - 仕入先コード(2桁)
 */
export const createProductMatrix = async (productData, supplierCode) => {
  const url = `${PRODUCT_ENDPOINT}/?supplier_code=${encodeURIComponent(supplierCode)}`;
  const response = await apiFetch(url, {
    method: 'POST',
    body: JSON.stringify(productData),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || '商品マスターの一括登録に失敗しました');
  }
  return response.json();
};

/**
 * 🌟 互換性のためのエイリアス
 * 新しい ProductList.jsx 内の「基本情報だけ（子は空配列）で送信する」処理にも100%対応
 */
export const createBasicProduct = createProductMatrix;


/**
 * 🌟 新設：商品マスターを条件（キーワード、カテゴリUUID）付きで取得する
 * 一覧画面でのリアルタイム検索とタブ切り替えに連動
 */
export const getProducts = async (keyword = '', categoryUuid = '', page = 1, limit = 10) => {
  // ページ番号からSQLの読み飛ばし位置（skip）を自動計算
  const skip = (page - 1) * limit;
  let url = `${PRODUCT_ENDPOINT}/?skip=${skip}&limit=${limit}`;

  if (keyword) url += `&keyword=${encodeURIComponent(keyword)}`;
  if (categoryUuid) url += `&category_uuid=${encodeURIComponent(categoryUuid)}`;

  const res = await apiFetch(url);
  if (!res.ok) throw new Error('商品マスター一覧の取得に失敗しました');
  return res.json();
};


/**
 * 🌟 新設：指定された商品の詳細情報をSKU一覧付きで取得する
 * 詳細画面（ProductDetail.jsx）が開いた瞬間に本物データをロード
 */
export const getProductDetail = async (uuid) => {
  const res = await apiFetch(`${PRODUCT_ENDPOINT}/${uuid}`);
  if (!res.ok) throw new Error('商品詳細データの取得に失敗しました');
  return res.json();
};


/**
 * 🌟 新設：既存の商品に対して、後からSKUを1件、バーコード自動生成付きで個別追加する
 * 詳細画面の下部フォームからポコポコSKUを足す処理に対応
 */
export const addSingleVariant = async (productUuid, supplierCode, variantData) => {
  const url = `${PRODUCT_ENDPOINT}/${productUuid}/variants?supplier_code=${encodeURIComponent(supplierCode)}`;
  const res = await apiFetch(url, {
    method: 'POST',
    body: JSON.stringify(variantData),
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.detail || 'バリエーションの追加に失敗しました');
  }
  return res.json();
};

